var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Echart',{ref:"centreLeft2ChartRef",attrs:{"id":"centreLeft2Chart","options":_vm.options,"height":"360px","width":"330px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }